module.exports = __webpack_public_path__ + "static/media/bio-6@2x.96acdb7d.jpg";